import { motion } from "framer-motion";
import { Instagram, Youtube, Facebook, Mail } from "lucide-react";

const socialLinks = [
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Youtube, href: "#", label: "YouTube" },
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Mail, href: "mailto:shrivrindanatyanjali@gmail.com", label: "Email" },
];

const quickLinks = [
  { name: "About", href: "#about" },
  { name: "Guru", href: "#guru" },
  { name: "Courses", href: "#courses" },
  { name: "Gallery", href: "#gallery" },
  { name: "Contact", href: "#enquiry" },
];

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer-bg py-16 border-t border-gold/10" data-testid="footer">
      <div className="container-custom">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo & Description */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h3 className="font-cinzel text-3xl font-bold">
              <span className="text-gold">Shri Kala</span>{" "}
              <span className="text-white">Vrinda</span>
            </h3>
            <p className="font-manrope text-white/50 text-sm leading-relaxed">
              A sacred space dedicated to the preservation and teaching of 
              Bharatanatyam, the divine dance form that connects body, mind, and spirit. Shri Kala Vrinda.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h4 className="font-cinzel text-lg text-gold">Quick Links</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="font-manrope text-white/50 hover:text-gold text-sm transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h4 className="font-cinzel text-lg text-gold">Connect</h4>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 border border-gold/30 flex items-center justify-center text-gold/60 hover:text-gold hover:border-gold transition-colors"
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
            <p className="font-manrope text-white/30 text-xs">
              Follow us for updates on classes and performances
            </p>
          </motion.div>
        </div>

        {/* Decorative Sanskrit Text */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center py-8 border-t border-white/5"
        >
          <p className="font-playfair text-2xl md:text-3xl text-gold/10">
            ॐ नमः शिवाय
          </p>
          <p className="font-manrope text-white/20 text-xs mt-2 tracking-widest">
            Om Namah Shivaya
          </p>
        </motion.div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-manrope text-white/30 text-xs">
            © {new Date().getFullYear()} Shri Kala Vrinda. All rights reserved.
          </p>
          <p className="font-manrope text-white/20 text-xs">
            Crafted with devotion for the art of Bharatanatyam
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
